export class PatientNotes {
  id: number;
  patientName: string;
  caseNumber: string;
  createdDateTime: Date;
  note: string;
  hasBeenSubmittedToSor: boolean;
  isSuccess: boolean;
  username: string;
  error: string;
}